/* ═══════════════════════════════════════════════════════════════
   CELVRA™ — Global Animations Engine
   Handles: scroll reveals, counters, stagger, FAQ accordions
═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── 1. Universal Scroll Reveal ────────────────────────────── */
  function initScrollReveal() {
    var selectors = [
      '[data-anim]',
      '[data-anim-fade]',
      '[data-anim-slide]',
      '[data-anim-scale]'
    ];

    var elements = document.querySelectorAll(selectors.join(','));
    if (!elements.length || !('IntersectionObserver' in window)) {
      /* Fallback: show everything */
      elements.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
          setTimeout(function() {
            el.classList.add('is-visible');
          }, delay);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.1 });

    elements.forEach(function(el) { observer.observe(el); });
  }

  /* ── 2. Counter Animation (0 → target) ────────────────────── */
  function animateCounter(el, target, prefix, suffix, duration) {
    var startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      /* ease-out cubic */
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target);
      el.textContent = (prefix || '') + current + (suffix || '');
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = (prefix || '') + target + (suffix || '');
      }
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var counterEls = document.querySelectorAll('[data-counter]');
    if (!counterEls.length || !('IntersectionObserver' in window)) return;

    counterEls.forEach(function(el) {
      var triggered = false;
      var obs = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting && !triggered) {
          triggered = true;
          animateCounter(
            el,
            parseInt(el.getAttribute('data-counter'), 10),
            el.getAttribute('data-prefix') || '',
            el.getAttribute('data-suffix') || '',
            parseInt(el.getAttribute('data-duration') || '2000', 10)
          );
          obs.unobserve(el);
        }
      }, { threshold: 0.3 });
      obs.observe(el);
    });
  }

  /* ── 3. FAQ Accordions ────────────────────────────────────── */
  function initFaqAccordions() {
    var triggers = document.querySelectorAll('[data-faq-trigger]');
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = trigger.closest('[data-faq-item]');
        if (!item) return;

        var content = item.querySelector('[data-faq-content]');
        if (!content) return;

        var isOpen = item.classList.contains('is-open');

        /* Close all siblings first (optional: remove for multi-open) */
        var parent = item.parentElement;
        if (parent) {
          parent.querySelectorAll('[data-faq-item].is-open').forEach(function(openItem) {
            if (openItem !== item) {
              openItem.classList.remove('is-open');
              var openContent = openItem.querySelector('[data-faq-content]');
              if (openContent) openContent.style.maxHeight = '0';
            }
          });
        }

        if (isOpen) {
          item.classList.remove('is-open');
          content.style.maxHeight = '0';
        } else {
          item.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  /* ── 4. Stagger children on scroll ────────────────────────── */
  function initStaggerChildren() {
    var containers = document.querySelectorAll('[data-stagger-children]');
    if (!containers.length || !('IntersectionObserver' in window)) return;

    containers.forEach(function(container) {
      var obs = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          var children = container.children;
          var baseDelay = parseInt(container.getAttribute('data-stagger-delay') || '100', 10);
          Array.prototype.forEach.call(children, function(child, i) {
            setTimeout(function() {
              child.classList.add('is-visible');
            }, i * baseDelay);
          });
          obs.unobserve(container);
        }
      }, { threshold: 0.1 });
      obs.observe(container);
    });
  }

  /* ── 5. Hero staggered reveal ─────────────────────────────── */
  function initHeroReveal() {
    var heroGrid = document.querySelector('[data-hero-reveal]');
    if (!heroGrid) return;

    /* Wait a tick for paint, then reveal */
    requestAnimationFrame(function() {
      heroGrid.classList.add('is-revealed');
    });
  }

  /* ── 6. Smooth scroll for anchor links ───────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var targetId = link.getAttribute('href');
        if (targetId === '#') return;
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── 7. Carousel auto-scroll (for athletes) ──────────────── */
  function initCarouselAutoScroll() {
    var carousels = document.querySelectorAll('[data-auto-carousel]');
    carousels.forEach(function(carousel) {
      var interval = parseInt(carousel.getAttribute('data-interval') || '4000', 10);
      var cards = carousel.children;
      if (cards.length <= 1) return;

      var currentIndex = 0;
      setInterval(function() {
        currentIndex = (currentIndex + 1) % cards.length;
        cards[currentIndex].scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }, interval);
    });
  }

  /* ── INIT ─────────────────────────────────────────────────── */
  function init() {
    initScrollReveal();
    initCounters();
    initFaqAccordions();
    initStaggerChildren();
    initHeroReveal();
    initSmoothScroll();
    initCarouselAutoScroll();
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init on Shopify section render (theme editor) */
  document.addEventListener('shopify:section:load', init);

})();
